import { colors, sizes } from "asset/constant";
import React from "react";
import { StyleSheet, View } from "react-native";
import { mq } from "utils";
import Icon from "component/typography/Icon";
import Text from "component/typography/Text";
import toastIconAndColor from "./toastIconAndColor";

export default function ToastBox(props: ToastT) {
  const { title, message, type } = props;

  const toastColor = toastIconAndColor(type).color;
  const toastIcon = toastIconAndColor(type).icon;

  return (
    <View style={{ ...styles.container, shadowColor: toastColor }}>
      <View style={styles.content}>
        <View style={styles.titleContainer}>
          <Text
            color={colors.text.dark}
            size={"lg"}
            style={styles.title}
            weight="bold"
          >
            {" "}
            {title}{" "}
          </Text>
          <Icon size={18} {...toastIcon} />
        </View>
        <View style={styles.messageContainer}>
          <Text style={{ lineHeight: 22 }}>{message}</Text>
        </View>
      </View>
      <View style={{ ...styles.verticalBar, backgroundColor: toastColor }} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "90%",
    maxWidth: mq(500),
    minHeight: mq(60),
    elevation: 10,
    alignSelf: "center",
    flexDirection: "row",
    backgroundColor: "#fff",
    borderRadius: sizes.radius.sm,
    borderWidth: 2,
    borderColor: "#dedede",
  },

  content: { flex: 1, padding: mq(5) },

  titleContainer: { flexDirection: "row", alignItems: "center" },

  title: { flex: 1 },

  messageContainer: { paddingHorizontal: mq(22) },

  verticalBar: {
    minHeight: 50,
    width: mq(20),
    borderTopRightRadius: sizes.radius.sm,
    borderBottomRightRadius: sizes.radius.sm,
  },
});
